import { Badge, Box, Button, Card, Flex, Heading, Image, getPaletteColor, theme } from 'pcln-design-system'
import React, { useId } from 'react'
import styled from 'styled-components'
import SimplifiedItinerary from '../SimplifiedItinerary'

const StyledCard = styled(Card)`
  :hover {
    box-shadow: ${theme.shadows['md']};
  }
`

const StyledButton = styled(Button)`
  color: ${(props) => getPaletteColor('primary.base')(props)};
`

const StyledBox = styled(Box)`
  white-space: nowrap;
`

function PromoListingsCard({
  airline,
  buttonText,
  dealPrice,
  departDate,
  destinationAirportCode,
  destinationCity,
  destinationImg,
  handleClick,
  headingLevel = 'h3',
  originAirportCode,
  returnDate,
  savingsText,
  strikePrice,
  tripDuration,
  tripType,
}) {
  const headingId = useId()

  return (
    <StyledCard boxShadowSize='sm' p={3} borderRadius={16} role='group' aria-labelledby={headingId}>
      <Flex flexDirection='row' mb={2}>
        <Image
          alt={`${destinationCity} image`}
          src={destinationImg}
          width='96px'
          height='72px'
          borderRadius='lg'
        />
        <Box pt={2} pl={2}>
          <Heading as={headingLevel} textStyle='heading5' pb={2} id={headingId}>
            {destinationCity}
          </Heading>
          <Badge bg='highlight.light' color='highlight.dark'>
            {savingsText}
          </Badge>
        </Box>
      </Flex>
      <StyledBox>
        <SimplifiedItinerary
          airline={airline}
          arrival={{ airport: destinationAirportCode, time: returnDate }}
          departing={{ airport: originAirportCode, time: departDate }}
          dollars={dealPrice}
          duration={tripDuration}
          strikePrice={strikePrice}
          tripType={tripType}
        />
      </StyledBox>
      <StyledButton
        aria-label={`${buttonText} - ${destinationCity}`}
        color='background.base'
        mt={2}
        onClick={handleClick}
        size='small'
        width='100%'
      >
        {buttonText}
      </StyledButton>
    </StyledCard>
  )
}

export default PromoListingsCard
